import ReactPDF from '@react-pdf/renderer'
import { CSSProperties } from '@material-ui/styles'


// Define BlockType
export type BlockType =
  | 'title'
  | 'subtitle'
  | 'text'
  | 'input'
  | 'table'
  | 'image'
  | 'enumeration'
  | 'list'


// Define InputType
export type InputType =
  | 'text'
  | 'email'
  | 'select'
  | 'contact'
  | 'money'
  | 'number'
  | 'date'
  | 'location'
  | 'address'
  | 'list'
  | 'multiselect'
  | 'sign'

// Define InputList
export const InputList: { type: InputType; name: string }[] = [
  { type: 'text', name: 'Texto' },  
  { type: 'email', name: 'Email' },
  { type: 'select', name: 'Desplegable' },
  { type: 'contact', name: 'Contacto' },
  { type: 'money', name: 'Moneda' },
  { type: 'number', name: 'Número' },
  { type: 'date', name: 'Fecha' },
  { type: 'list', name: 'Lista' },
  { type: 'multiselect', name: 'Selección múltiple' },
  { type: 'location', name: 'Domicilio' },
  { type: 'address', name: 'Dirección' },
  { type: 'sign', name: 'Firma' },
]

/**
 * Define DataColumn interface
 */
export interface IDataColumn {
  data?: string
  length: number
  input?: number
  style?: ReactPDF.Style
}

/**
 * Define dataRow interface
 */
export interface IDataRow {
  columns: IDataColumn[]
}

/**
 * Define InputValue interface
 */
export interface IInputValue {
  uid: string
  value: string
  noFormatValue: any
  options?: string
  /* suggestions?: string */
  conditional?: string
  type: InputType
  pos?: number
}

/**
 * Define Input interface
 */
export interface IInput {
  uid: string
  type: InputType
  options?: string
  startWith?: number
  label?: string
  conditional?: string
  info?: string
  obligatory?: boolean
  /* suggestions?: string */
}

/**
 * Define Block interface
 */
export interface IBlock {
  uid: string
  type: BlockType
  input?: string
  show?: string
  text?: string
  enter?: boolean
  columns?: number
  dataRow?: IDataRow[]
  style?: CSSProperties
}

/**
 * Define TemplateData interface
 */
export interface ITemplateData {
  header?: IBlock
  footer?: IBlock
  blocks: IBlock[]
  inputs: IInput[]
  HTMLCode: string
}

/**
 * Define Template interface
 */
export interface ITemplate {
  id: string
  author?: string
  name: string
  description?: string
  price?: number
  template_status: string
  template_status_id: number
  template_types: string
  template_type_id: number
  template_data?: ITemplateData
  created_at: Date
  updated_at: Date
}

/**
 * Define TemplateTypes interface
 */
export interface ITemplateTypes{
  id: number,
  name: string,
  description: string,
}

// Define TemplateStatus
export enum TEMPLATE_STATUS {
  DRAFT = 'Borrador',
  ACTIVE = 'Activo',
  INACTIVE = 'Inactivo',
}

// Define TemplateTypes
export enum TEMPLATE_TYPES {
  CONTRACTS = 'Contratos',
  GUARDIANSHIP = 'Tutelas',
  PETITION = 'Derechos de Petición, Reclamaciones y Denuncias',
  CLAIMS = 'Desacatos y Hábeas Corpus',
  LETTERS = 'Cartas, Comunicaciones, Modelos de Respuestas',
  OTHERS = 'Otros documentos',
}

// Define TemplateStatusMap
export const TemplateStatusMap = new Map()
TemplateStatusMap.set(TEMPLATE_STATUS.DRAFT, { id: 1, name: 'Borrador' })
TemplateStatusMap.set(TEMPLATE_STATUS.ACTIVE, { id: 2, name: 'Activo' })
TemplateStatusMap.set(TEMPLATE_STATUS.INACTIVE, { id: 3, name: 'Inactivo' })

// Define TemplateTypesMap
export const TemplateTypesMap = new Map()
TemplateTypesMap.set(TEMPLATE_TYPES.CONTRACTS, { id: 1, name: 'Contratos' })
TemplateTypesMap.set(TEMPLATE_TYPES.GUARDIANSHIP, { id: 2, name: 'Tutelas' })
TemplateTypesMap.set(TEMPLATE_TYPES.PETITION, { id: 3, name: 'Derechos de Petición, Reclamaciones y Denuncias' })
TemplateTypesMap.set(TEMPLATE_TYPES.CLAIMS, { id: 4, name: 'Desacatos y Hábeas Corpus' })
TemplateTypesMap.set(TEMPLATE_TYPES.LETTERS, { id: 5, name: 'Cartas, Comunicaciones, Modelos de Respuestas' })
TemplateTypesMap.set(TEMPLATE_TYPES.OTHERS, { id: 6, name: 'Otros documentos' })